export enum DocsVerificationFileUploadApproachEnum {
    PHOTO_AND_FILE = 'PHOTO_AND_FILE',
    PHOTO = 'PHOTO',
    FILE = 'FILE',
}
